import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Card,
  CardHeader,
  Table,
  Container,
  Row,
  Input,
  Button,
  Spinner
} from "reactstrap";
import { ToastContainer, toast } from "react-toastify"; // Import Toastify
import "react-toastify/dist/ReactToastify.css"; // Import Toastify CSS

const UserList = () => {
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false); // Loading state to show spinner

  // Fetch filtered users from the server
useEffect(() => {
  const fetchUsers = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/formuser`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        }
      });
      setUsers(response.data.users);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };
  fetchUsers();
}, []);

  // Reset register_form for a specific user
const resetUserForm = async (userId) => {
  try {
    const token = localStorage.getItem('token');
    await axios.put(`${process.env.REACT_APP_API_URL}/users/${userId}/reset-form`, 
      {}, // Empty body if no data needed
      {
        headers: {
          'Authorization': `Bearer ${token}`,
        }
      }
    );
    
    // Update UI to reflect the change without re-fetching all data
    setUsers((prevUsers) =>
      prevUsers.map((user) =>
        user.id === userId ? { ...user, register_form: null } : user
      )
    );

    // Show toast notification after resetting the register form
    toast.success("User register form status has been reset!");

    // Reload the page after 3 seconds (to allow the toast to appear)
    setTimeout(() => {
      window.location.reload();
    }, 3000);
  } catch (error) {
    console.error("Error resetting user form status:", error);
    toast.error("Failed to reset the user form status.");
  }
};

  // Filter users based on the search term
  const filteredUsers = users.filter((user) => {
    const lowerCaseSearchTerm = searchTerm.toLowerCase();
    return (
      user.name?.toLowerCase().includes(lowerCaseSearchTerm) ||
      user.email?.toLowerCase().includes(lowerCaseSearchTerm) ||
      user.wallet?.toLowerCase().includes(lowerCaseSearchTerm)
    );
  });

  return (
    <Container style={{ border: "none", backgroundColor: "rgba(1,1,1,0.2)", padding: "0", maxWidth: "100%",paddingTop:'100px' }}>
      <Row style={{ border: "none", backgroundColor: "rgba(1,1,1,0.2)", margin: "0" }}>
        <div className="col" style={{ padding: "0" }}>
          <Card style={{ border: "none", backgroundColor: "rgba(1,1,1,0.2)" }}>
            <CardHeader className="border-0" style={{ backgroundColor: "rgba(1,1,1,0.2)", border: "none" }}>
              <h3 className="mb-0" style={{ color: "white", fontSize: "40px", fontWeight: "bolder" }}>
                Register Form Status
              </h3>
            </CardHeader>

            {/* Search input */}
            <div style={{ margin: "10px", padding: "10px" }}>
              <Input
                type="text"
                placeholder="Search by full name, email, or wallet address"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{ width: "100%", fontSize: "1rem",background:'black',color:'white',border:'none' }}
              />
            </div>

            {/* Loader and Table */}
            {loading ? (
              <div style={{ textAlign: "center", marginTop: "20px" }}>
                <Spinner color="primary" />
                <p style={{ color: "white", marginTop: "10px" }}>Loading...</p>
              </div>
            ) : (
              <Table responsive style={{ width: "100%", tableLayout: "auto" }}>
                <thead>
                  <tr>
                    <th style={{ color: "white", fontSize: "0.7rem", backgroundColor: "rgba(1,1,1,0.2)", border: "none" }}>
                      Wallet Address
                    </th>
                    <th style={{ color: "white", fontSize: "0.7rem", backgroundColor: "rgba(1,1,1,0.2)", border: "none" }}>
                      Register Form Status
                    </th>
                    <th style={{ color: "white", fontSize: "0.7rem", backgroundColor: "rgba(1,1,1,0.2)", border: "none" }}>
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredUsers.map((user) => (
                    <tr key={user.id} style={{ border: "none" }}>
                      <td style={{ color: "white", border: "none" }}>{user.wallet}</td>
                      <td style={{ color: "white", border: "none" }}>
                        {user.register_form ? "True" : "False"}
                      </td>
                      <td style={{ color: "white", border: "none" }}>
                        <Button color="primary" size="sm" onClick={() => resetUserForm(user._id)}>
                          Show Form to User
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </Card>
        </div>
      </Row>

      {/* Toast container for showing notifications */}
      <ToastContainer />
    </Container>
  );
};

export default UserList;
